// ROUTINE GUIDE - JAVASCRIPT FINALE

document.addEventListener('DOMContentLoaded', function() {
  
  const tabs = document.querySelectorAll('.routine-tab');
  const panels = document.querySelectorAll('.routine-panel');
  
  // Funzione per mostrare pannello
  function showPanel(targetId) {
    // Nascondi tutti i pannelli
    panels.forEach(panel => {
      panel.classList.remove('active');
    });
    
    // Mostra il pannello target
    const targetPanel = document.getElementById(targetId);
    if (targetPanel) {
      targetPanel.classList.add('active');
    }
  }
  
  // Funzione per aggiornare tab attivi
  function updateActiveTabs(activeTab) {
    tabs.forEach(tab => {
      tab.classList.remove('active');
    });
    activeTab.classList.add('active');
  }
  
  // Event listeners per i tab
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      
      updateActiveTabs(this);
      showPanel(targetId);
    });
  });
  
  // Assicura che il primo pannello sia visibile
  if (panels.length > 0 && tabs.length > 0) {
    tabs[0].classList.add('active');
    panels[0].classList.add('active');
  }
  
});